import React, { useState } from "react";
import "../styles/Footer.css";

import {
  FaFacebookF,
  FaLinkedinIn,
  FaInstagram,
  FaWhatsapp,
  FaPhoneAlt,
  FaEnvelope,
} from "react-icons/fa";

import logofooter from "../assets/images/logos.webp";

const Footer = () => {
  const [openSection, setOpenSection] = useState(null);

  const toggleSection = (section) => {
    setOpenSection(openSection === section ? null : section);
  };

  return (
    <>
      <footer className="footer">
        <div className="footer-top">
          <div className="footer-about">
            <h2 className="logo-foter">
              <img src={logofooter} alt="Logo" />
            </h2>

            <p className="tagline">Empower Web</p>

            <p className="descc">
              Empower Web delivers innovative digital solutions that drive
              growth, boost online presence, and empower businesses with modern
              web design, development, SEO, and marketing strategies for
              sustainable success in the digital era.
            </p>
          </div>

          <div className="footer-links">
            {/* SERVICES */}

            <div>
              <h3
                className="footer-heading"
                onClick={() => toggleSection("services")}
              >
                Our Services
              </h3>

              <ul
                className={`footer-list ${
                  openSection === "services" ? "open" : ""
                }`}
              >
                <li>
                  <a href="/web-development-company-in-noida">
                    Web Development
                  </a>
                </li>

                <li>
                  <a href="/web-design-services">Web Design</a>
                </li>

                <li>
                  <a href="/seo-agency-noida">
                    Search Engine Optimization
                  </a>
                </li>

                <li>
                  <a href="/content-marketing-services">
                    Content Marketing
                  </a>
                </li>

                <li>
                  <a href="/ai-automation-services">AI Automation</a>
                </li>

                <li>
                  <a href="/sales-funnel-optimization">
                    Sales Funnel Optimization
                  </a>
                </li>

                <li>
                  <a href="/branding-agency-noida">Branding Service</a>
                </li>
              </ul>
            </div>

            {/* COMPANY */}

            <div>
              <h3
                className="footer-heading"
                onClick={() => toggleSection("company")}
              >
                Company
              </h3>

              <ul
                className={`footer-list ${
                  openSection === "company" ? "open" : ""
                }`}
              >
                <li>
                  <a href="/about">About Us</a>
                </li>

                <li>
                  <a href="/Blog">Our Blogs</a>
                </li>

                <li>
                  <a href="/contact">Contact Us</a>
                </li>
              </ul>
            </div>

            {/* QUICK LINKS */}

            <div>
              <h3
                className="footer-heading"
                onClick={() => toggleSection("quick")}
              >
                Quick Links
              </h3>

              <ul
                className={`footer-list ${
                  openSection === "quick" ? "open" : ""
                }`}
              >
                <li>
                  <a href="/about">About Us</a>
                </li>

                <li>
                  <a href="/contact">Contact Us</a>
                </li>

                <li>
                  <a href="/portfolio">Portfolio</a>
                </li>

                <li>
                  <a href="/Testimonials">Client Testimonials</a>
                </li>

                <li>
                  <a href="/Terms">Terms</a>
                </li>
              </ul>
            </div>

            {/* LOCATION */}

            <div>
              <h3
                className="footer-heading"
                onClick={() => toggleSection("location")}
              >
                Location
              </h3>

              <ul
                className={`footer-list ${
                  openSection === "location" ? "open" : ""
                }`}
              >
                <li>Location :- Sector-62, Noida, India</li>

                <li>
                  <a href="tel:+919315020291">
                    Phone :- +91 9315020291
                  </a>
                </li>

                <li>
                  <a href="mailto:connect@empowerweb.in">
                    Email :- connect@empowerweb.in
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* FOOTER BOTTOM */}

        <div className="footer-bottom">
          <div className="social-icons">
            <a
              href="https://www.facebook.com/share/16o9q8iR5U/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Empower Web Facebook"
            >
              <FaFacebookF />
            </a>

            <a
              href="https://www.instagram.com/empowerweb_bdp?igsh=MTlvaGNzZTltN3hzYw=="
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Empower Web Instagram"
            >
              <FaInstagram />
            </a>

            <a
              href="https://www.linkedin.com/company/empower-web/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Empower Web LinkedIn"
            >
              <FaLinkedinIn />
            </a>
          </div>

          <p>Copyright © 2026 Empower Web®. All rights reserved.</p>

          <div className="policies">
            <a href="/sitemap.xml">Sitemap</a>
            <a href="/privacy-policy">Privacy Policy</a>
          </div>
        </div>
      </footer>

      {/* MOBILE FIXED BUTTONS */}

      <div className="mobile-contact-bar">
        <a href="tel:+918368327503" className="contact-btn call-btn">
       
          <span>Call</span>   <FaPhoneAlt />
        </a>

        <a
          href="mailto:connect@empowerweb.in"
          className="contact-btn email-btn"
        >
         
          <span>Email</span>
           <FaEnvelope />
        </a>
         <a
          href="https://wa.me/918368327503?text=Hi%20Empower%20Web%2C%20I%20would%20like%20to%20discuss%20my%20project."
         target="_blank"
          rel="noopener noreferrer"
          title="Chat with us on WhatsApp"
           className="contact-btn whatsapp-btn"
        >
        
          <span>whatsapp</span>  < FaWhatsapp />
        </a>
      </div>

      {/* WHATSAPP BUTTON */}

      <div className="whatsapp-container">
        <div className="chat-text">Need Help? Chat with us</div>

        <a
          href="https://wa.me/918368327503?text=Hi%20Empower%20Web%2C%20I%20would%20like%20to%20discuss%20my%20project."
          target="_blank"
          rel="noopener noreferrer"
          title="Chat with us on WhatsApp"
          className="whatsapp-icon"
        >
          <FaWhatsapp size={35} color="white" />
        </a>
      </div>
    </>
  );
};

export default Footer;